import { useCallback } from 'react';
import { usePathname, useRouter } from 'expo-router';

import { useNavigateBack } from '../../navigation';

// Closes the bag if it's open.
export const useCloseBag = () => {
  const isBagOpen = useIsBagOpen();
  const { handleCloseBag } = useBagNavigation();

  return useCallback(() => {
    if (isBagOpen) handleCloseBag();
  }, [handleCloseBag, isBagOpen]);
};

// Returns whether the bag is opened by using the active route name.
export const useIsBagOpen = () => {
  const pathname = usePathname();

  return pathname === '/bag';
};

// ─── Helpers ────────────────────────────────────────────────────────────────

const useBagNavigation = () => {
  const router = useRouter();

  // This just opens the bag screen on the modal stack.
  const handleOpenBag = useCallback(() => {
    router.navigate('/bag');
  }, [router]);

  // This will go back on the parent (dismiss the modal stack),
  // It will go back in the modal stack if needed.
  const handleCloseBag = useNavigateBack();

  return {
    handleOpenBag,
    handleCloseBag,
  };
};
